<!-- eslint-disable max-len -->
<template>
  <div class="about-ois_aoi" :class="{ [curTheme]: true }">

    <page-header>
      <h1>Цифровые объекты авторского права (ЦОАП)</h1>
    </page-header>

    <page-text>
      <div class="aoi_content">
        <p>Платформа ориентирована на различные объекты авторского права, которые создаются в организациях научно-образовательного комплекса.</p>
        <p>К таким объектам относятся:</p>
      </div>

      <div class="aoi_items">

        <div
          v-for="(v, i) in items"
          class="aoi_item"
          :key="`item-${i}`"
          @click="showDialog(v)">
          <div class="aoi_hex">
            <img class="aoi_icon" :class="`aoi_${v.type}`"
                 :src="`/static/grx/icons/objects/${v.type}.svg`">
          </div>
          <span class="aoi_text">{{ v.title }}</span>
        </div>

      </div>

      <el-dialog
        v-if="curItem"
        :title="curItem.title"
        class="aoi_dialog_apd"
        :visible.sync="dialogVisible">
        <div class="apd_desc">
          <img class="apd_icon" :class="`apd_${curItem.type}`"
            :src="`/static/grx/icons/objects/${curItem.type}.svg`">
          <div>{{ curItem.desc }}</div>
          <template v-if="catalog && oisNumber(curItem.type)">
            <div class="apd_number-link">
              Количество
              <span class="apd_number">
                {{ oisNumber(curItem.type) }}</span>
              <router-link
                :to="`/objects/search?type=${curItem.type}`"
                class="apd_link">
                Посмотреть</router-link>.
            </div>
          </template>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            class="vivid-button"
            @click="dialogVisible = false">
            Закрыть
          </el-button>
        </span>
      </el-dialog>

    </page-text>

    <page-footer/>
  </div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageText from '../PageText';
import PageFooter from '../PageFooter';

export default {

  components: { PageHeader, PageText, PageFooter },

  data() {
    return {
      dialogVisible: false,
      curItem: null,
      catalog: null,
      items: [],
    };
  },

  created() {
    axios.get('objects/types').then((r) => {
      r.data.forEach((type) => {
        this.items.push({
          type: type.Type,
          title: type.Title,
          desc: type.Description,
        });
      });
    }).catch(() => {});
    axios.get('objects/catalog').then((r) => {
      this.catalog = r.data;
    }).catch(() => {});
  },

  methods: {

    showDialog(item) {
      this.curItem = item;
      this.dialogVisible = true;
    },

    oisNumber(type) {
      let number = 0;
      if (this.catalog.Types[type]) {
        number = this.catalog.Types[type].Number;
      }
      return number;
    },
  },

};
</script>

<style lang="scss">
@import '../../styles/common/main';

.aoi_content {
  margin: 0 auto 20px;
}

.about-ois_aoi {
  .aoi_items {
    @include clearfix;
    margin: 0 auto;
    .aoi_item {
      width: 33.3333333%;
      float: left;
      padding: 0 10px;
      position: relative;
      @include clearfix;
      margin: 20px 0;
      cursor: pointer;
      &:hover {
        .aoi_text {
          color: #fff;
        }
      }
      @media (max-width: 1100px) {
        width: 50%;
      }
      @media (max-width: 730px) {
        width: 100%;
        max-width: 350px;
        margin-left: auto;
        margin-right: auto;
        float: none;
        padding: 0;
      }
      .aoi_hex {
        width: 110px;
        height: 117px;
        position: relative;
        background: url('/static/grx/hex/white-shadow.png');
        background-size: contain;
        @media (max-width: 730px) {
          width: 80px;
          height: 87px;
        }
      }
      .aoi_icon {
        position: absolute;
        z-index: 1;
        top: 50%;
        left: 50%;
        margin-left: -21px;
        transform: translateY(-50%);
        width: 42px;
        height: auto;
        display: inline-block;
        &.aoi_icon--vert {
          height: 42px;
        }
        @media (max-width: 730px) {
          width: 34px;
          margin-left: -17px;
        }
      }
      .aoi_text {
        font-size: 18px;
        line-height: 23px;
        font-weight: 300;
        display: block;
        position: absolute;
        color: #d3d3d3;
        transition: color .3s;
        top: 50%;
        left: 125px;
        transform: translateY(-50%);
        @media (max-width: 730px) {
          font-size: 16px;
          line-height: 21px;
          left: 90px;
          color: #fff;
        }
      }
    }
  }

  &.theme-w {
    .aoi_items {
      .aoi_item {
        .aoi_text {
          color: #666 !important;
        }
        &:hover {
          .aoi_text {
            color: #000 !important;
          }
        }
      }
    }
  }
}

.aoi_dialog_apd {
  .apd_desc {
    padding-left: 55px;
    position: relative;
    .apd_icon {
      position: absolute;
      left: 0;
      top: 0;
      width: 42px;
      height: auto;
    }
    .apd_number-link {
      margin: 15px 0 0;
      .apd_number {
        display: inline-block;
        background-color: #a95e7f;
        color: #fff;
        padding: 4px 12px 1px;
        border-radius: 15px;
        margin: 0 5px;
        font-size: 13px;
      }
      .apd_link {
        color: #f4466f;
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/AboutOis.vue